<template>
<div id="payment-method" v-if="!settingScreen.title">
    <div class="tab-header">
        <label class="tab-title">{{ $t("_PAYGATE.PAYMENT_METHOD") }}</label>
    </div>
    <div class="tab-content">
        <div>
            <div class="row">
                <v-subheader class="p-0">{{  $t("_PAYGATE.PAYMENT_THROUGH") }}</v-subheader>
                <v-layout wrap>
                    <v-checkbox class="col-md-6 ckb-ezCloud" color="indigo darken-3" label="ezCloud" value="EZCLOUD" v-model="data.paymentTypes" :disabled="isOnsite"></v-checkbox>
                    <v-checkbox class="col-md-6 ckb-hotel" color="indigo darken-3" :label="$t('_PAYGATE.HOTEL')" value="HOTEL" v-model="data.paymentTypes" :disabled="isOnsite"></v-checkbox>
                </v-layout>
            </div>
            <template v-if="data.paymentTypes && data.paymentTypes.includes('HOTEL')">
                <div class="row">
                    <v-subheader class="p-0">{{ $t("_PAYGATE.PAYMENT_METHOD") }}</v-subheader>
                    <v-layout wrap>
                         <div class="mb-3 p-0">
                            <label class="label-input">{{ $t("CHOOSE_LANG_PAYMENT") }}</label>
                            <b-form-select
                                :options="langPaymentOption" 
                                v-model="langPayment"
                                />
                        </div>
                        <v-checkbox class="col-md-12 ckb-method-transfer" color="indigo darken-3" :label="$t('_PAYGATE.TRANSFER_PAYMENT')" v-model="data.paymentTransfer" :disabled="isOnsite"></v-checkbox>
						<div class="div-info-payment mb-5 col-md-12" v-if="data.paymentTransfer === true">
							<p class="mb-1">{{$t('CONTENT_WIDGETS')}}</p>
							<b-form-textarea id="textarea" v-model="paymentTransferInfo[langPayment]" :placeholder="$t('ENTER_CONTENT_SHOW')" rows="3" max-rows="6" :disabled="isOnsite"></b-form-textarea>
						</div>
                        <v-checkbox class="col-md-12 ckb-method-online" color="indigo darken-3" :label="$t('_PAYGATE.CASH')" v-model="data.paymentCash" :disabled="isOnsite"></v-checkbox>
						<div class="div-info-payment mb-5 col-md-12" v-if="data.paymentCash">
							<p class="mb-1">{{$t('CONTENT_WIDGETS')}}</p>
							<b-form-textarea id="textarea" v-model="paymentCashInfo[langPayment]" :placeholder="$t('ENTER_CONTENT_SHOW')" rows="3" max-rows="6" :disabled="isOnsite"></b-form-textarea>
						</div>	
                        <v-checkbox class="col-md-12 ckb-method-online" color="indigo darken-3" :label="$t('_PAYGATE.DEBT')" v-model="data.paymentDebt" :disabled="isOnsite"></v-checkbox>
						<div class="div-info-payment mb-5 col-md-12" v-if="data.paymentDebt">
							<p class="mb-1">{{$t('CONTENT_WIDGETS')}}</p>
							<b-form-textarea id="textarea" v-model="paymentDebtInfo[langPayment]" :placeholder="$t('ENTER_CONTENT_SHOW')" rows="3" max-rows="6" :disabled="isOnsite"></b-form-textarea>
						</div>
						<v-checkbox class="col-md-12 ckb-method-online" color="indigo darken-3" :label="$t('_PAYGATE.ONLINE_PAYMENT')" @change="regisPaymentOnline(data.paymentOnline)" v-model="data.paymentOnline" :disabled="isOnsite"></v-checkbox>
                    </v-layout>
                </div>
                <div class="row pay-gate-online" v-if="data.paymentOnline">
                    <v-subheader class="p-0">{{ $t("_PAYGATE.ONLINE_PAYMENT_GATEWAY") }}:</v-subheader>
                    <v-layout wrap>
                        <div class="col-md-4 mb-2" v-for="item in data.paygates" :key="item.code">
                            <v-checkbox class="mt-0" :id="'ckb-gate-' + item.code" color="indigo darken-3" :label="item.name" :value="item.code" v-model="paymentsMethod" :disabled="isOnsite"></v-checkbox>
                            <div class="setting">
                                <button :class="{ 'has-action': !item.done }" :disabled="!paymentsMethod.includes(item.code)" @click="goToSetting(item)">
                                    {{ $t("_PAYGATE.CONFIGURATION") }}
                                </button>
                                <v-icon :color="item.done ? '' : 'indigo'" :disabled="!paymentsMethod.includes(item.code)" @click="goToSetting(item)">settings</v-icon>
                            </div>
                        </div>
                    </v-layout>
                </div>
            </template>
            <div class="btn-bottom">
                <button class="btn btn-save" @click="save" :disabled="isOnsite">
                    {{ $t("SAVE") }}
                </button>
            </div>
        </div>
    </div>
</div>
<div v-else>
    <pay-gate-setting :data.sync="settingScreen.data" @backToParent="back" :isOnsite="isOnsite">
        <label slot="header" class="tab-title">
            {{ $t("_PAYGATE.CONFIG_PAYMENT_GATE") }}
        </label>
        <b slot="subheader">{{ settingScreen.title }}</b>
    </pay-gate-setting>
</div>
</template>

<script>
import PayGetSetting from "./PayGateSetting.vue";
import {
    _alert,
    _resetErrorState
} from "@/_helpers/function.js";
import {
    service
} from "@/_services/HotelSetting/payment-gate.service.js";
import {
    ONLINE_PAY_GATE,
    PG_ERROR
} from "@/_helpers/config.js";
export default {
    components: {
        "pay-gate-setting": PayGetSetting,
    },
    data() {
        return {
            paymentsMethod: [],
            data: {
                paymentType: null,
                paymentOnline: null,
                paymentTransfer: null,
                paymentGateWays: {
                    paymentGateWayId: null,
                    paymentSettingModels: [],
                },
            },
            paymentTypeError: {
                ezCloud: false,
                hotel: false,
            },
            paymentMethodError: {
                paymentTransfer: false,
                paymentOnline: false,
                paymentCash: false,
                paymentDebt: false,
            },
            error: PG_ERROR,
            onlinePayGate: ONLINE_PAY_GATE,

            currentSettingId: null,
            settingScreen: {
                id: null,
                title: null,
                data: null,
            },
            langSystem: this.$i18n.locale,
            isOnsite: false,
            //
            test: null,
             paymentCashInfo: {
                vi: null,
                en: null,
            },
            paymentDebtInfo: {
                vi: null,
                en: null,
            },
            paymentTransferInfo: {
                vi: null,
                en: null,
            },
            langPayment: 'vi',
            langPaymentOption: [
                { value: 'vi', text: this.$t("VI") },
                { value: 'en', text: this.$t("EN") },
            ],
        };
    },
    async created() {
        await this.initialize();
    },
    mounted() {
        document
            .querySelector(".v-tab.v-tab--active")
            .classList.remove("v-tab--active");
        document
            .querySelector(".v-tab[tabIndex='3']")
            .classList.add("v-tab--active");
    },
    watch: {
        data: {
            handler(value) {
                if (!this.data.paymentTypes.includes("HOTEL")) {
                    this.data.paymentOnline = false;
                    this.data.paymentTransfer = false;
                    this.data.paymentCash = false;
                    this.data.paymentDebt = false;
                }
            },
            deep: true,
        },
        error: {
            handler(value) {
                for (let i = 1; i <= value.length; i++) {
                    let elm = document.querySelector(`label[for=ckb-gate-${i}]`);
                    if (elm) {
                        if (value.find((x) => x.id == i).error) {
                            elm.classList.add("cm-text-error");
                        } else {
                            elm.classList.remove("cm-text-error");
                        }
                    }
                }
            },
            deep: true,
        },
        paymentTypeError: {
            handler(value) {
                let ezCloud = document.querySelector(".ckb-ezCloud label");
                let hotel = document.querySelector(".ckb-hotel label");
                if (value.ezCloud && ezCloud) {
                    ezCloud.classList.add("cm-text-error");
                } else {
                    ezCloud.classList.remove("cm-text-error");
                }
                if (value.hotel && hotel) {
                    hotel.classList.add("cm-text-error");
                } else {
                    hotel.classList.remove("cm-text-error");
                }
            },
            deep: true,
        },
        paymentMethodError: {
            handler(value) {
                let transfer = document.querySelector(".ckb-method-transfer label");
                let online = document.querySelector(".ckb-method-online label");
                if (value.paymentTransfer && transfer) {
                    transfer.classList.add("cm-text-error");
                } else {
                    transfer.classList.remove("cm-text-error");
                }
                if (value.paymentOnline && online) {
                    online.classList.add("cm-text-error");
                } else {
                    online.classList.remove("cm-text-error");
                }
            },
            deep: true,
        },
    },
    computed: {},
    methods: {
        async initialize() {
            //  this.getSettingPayment();
            _resetErrorState(this.error);
            await service.getGatewayInfo().then((res) => {
                this.data = Object.assign({}, res.data);
                this.paymentCashInfo['vi'] = this.data.paymentCashInfoI18ns.filter(e => e.langCode === 'vi')[0].title;
                this.paymentCashInfo['en'] = this.data.paymentCashInfoI18ns.filter(e => e.langCode === 'en')[0].title;
                this.paymentDebtInfo['vi'] = this.data.paymentDebtInfoI18ns.filter(e => e.langCode === 'vi')[0].title;
                this.paymentDebtInfo['en'] = this.data.paymentDebtInfoI18ns.filter(e => e.langCode === 'en')[0].title;
                this.paymentTransferInfo['vi'] = this.data.paymentTransferInfoI18ns.filter(e => e.langCode === 'vi')[0].title;
                this.paymentTransferInfo['en'] = this.data.paymentTransferInfoI18ns.filter(e => e.langCode === 'en')[0].title;
                this.data.payments = [];
                if (this.data.hotelStatus == 11 || this.data.hotelStatus == 12) {
                    this.isOnsite = true;
                }
                if (this.data.paymentOnline === true) {
                    this.getSettingPayment();
                }
            });
        },
        // dang ky cong thanh toan truc tuyen
        async regisPaymentOnline(value) {
            if (value === true) {
                await service.regisPaymentOnline().then((res) => {
                    // this.data = Object.assign({}, res.data);
                    if (res.responseCode === 0) {
                        this.getSettingPayment();
                    }
                });
            }
        },

        //
        async getSettingPayment() {
            let paygates = await service.getPaymentGate(); // lay all cac cong thanh toan
            let getGatewayConfig = await service.getGatewayConfig(); // lay cac cong da setting
            Vue.set(this.data, "paymentGateWays", getGatewayConfig.data); // cac cong da setting
            Vue.set(this.data, "paygates", paygates.data); //  all cong thanh toan

            // check tich cong thanh toan
            this.paymentsMethod = [];
            this.data.paygates.forEach((element) => {
                element.done = false;
                element.check = false;
                element.params.forEach((param) => {
                    param.value = null;
                });
                getGatewayConfig.data.forEach((item) => {
                    // gan value cac cong da dc setting
                    if (item.code === element.code) {
                        element.params.forEach((param) => {
                            item.params.forEach((itemConfig) => {
                                if (itemConfig.key === param.key) {
                                    param.value = itemConfig.value;
                                }
                            });
                        });
                    }
                });

                getGatewayConfig.data.forEach((e) => {
                    if (element.code === e.code && e.active === true) {
                        element.done = true;
                        element.check = true;
                        this.paymentsMethod.push(element.code);
                    } else if (element.code === e.code && e.active === false) {
                        element.done = true;
                        element.check = false;
                    }
                });
            });
        },
        back() {
            this.settingScreen.title = null;
        },
        save() {
            let isValid = this.validate();
            if (!isValid) {
                this.$store.commit("alert/display", {
                    message: this.$t("MISSING_FIELD"),
                    error: true,
                    success: false,
                });
                return false;
            }
            let listRemoved = [];
            if (this.data.paygates) {
                this.data.paygates.forEach((x, i) => {
                    if (!this.paymentsMethod.includes(x.code)) {
                        listRemoved.push(x.code);
                    }
                });
            }
            if (listRemoved.length > 0) {
                listRemoved.forEach((element) => {
                    service.deativeMethod(element).then((res) => {
                        // _alert(res, this.$t(res.data));
                    });
                });
            }
            let temp = {
                paymentTypes: this.data.paymentTypes,
                paymentOnline: this.data.paymentOnline,
                paymentTransfer: this.data.paymentTransfer,
                paymentCash: this.data.paymentCash,
                paymentDebt: this.data.paymentDebt,
				 paymentTransferInfoI18ns: [
                    {
                        langCode: 'vi',
                        title: this.paymentTransferInfo['vi'] === '' ? null : this.paymentTransferInfo['vi']
                    },
                    {
                        langCode: 'en',
                        title: this.paymentTransferInfo['en'] === '' ? null : this.paymentTransferInfo['en']
                    }
                ],
                paymentCashInfoI18ns: [
                    {
                        langCode: 'vi',
                        title: this.paymentCashInfo['vi'] === '' ? null : this.paymentCashInfo['vi']
                    },
                    {
                        langCode: 'en',
                        title: this.paymentCashInfo['en'] === '' ? null : this.paymentCashInfo['en']
                    }
                ],
                paymentDebtInfoI18ns: [
                    {
                        langCode: 'vi',
                        title: this.paymentDebtInfo['vi'] === '' ? null : this.paymentDebtInfo['vi']
                    },
                    {
                        langCode: 'en',
                        title: this.paymentDebtInfo['en'] === '' ? null : this.paymentDebtInfo['en']
                    }
                ],
            };
            service.update(temp).then((res) => {
                _alert(res, this.$t(res.data));
            });
        },
        validate() {
            let isValid = true;
            // Không chọn phương thức thanh toán
            if (!this.data.paymentTypes.length) {
                this.paymentTypeError.hotel = true;
                this.paymentTypeError.ezCloud = true;
                isValid = false;
            }
            if (isValid && !this.data.paymentTypes.includes("HOTEL")) {
                return true;
            }
            // Chọn thanh toán trực tuyến, không chọn cổng thanh toán
            if (this.data.paymentOnline && this.paymentsMethod.length == 0) {
                this.error.forEach((x) => {
                    x.error = true;
                    isValid = false;
                });
            } else if (
                !this.data.paymentTransfer &&
                !this.data.paymentOnline &&
                !this.data.paymentCash
            ) {
                this.paymentMethodError.paymentTransfer = true;
                this.paymentMethodError.paymentOnline = true;
                this.paymentMethodError.paymentCash = true;
                this.paymentMethodError.paymentDebt = true;
                isValid = false;
            } else if (
                (this.data.paymentTransfer ||
                    this.data.paymentCash ||
                    this.data.paymentDebt) &&
                !this.data.paymentOnline
            ) {
                return true;
            }
            // Chọn cổng thanh toán, chưa cấu hình
            else {
                this.paymentsMethod.forEach((x) => {
                    // cac cong dc tich
                    let id = x;
                    if (
                        typeof this.data.paymentGateWays.find(
                            // tim xem co cong setting hay chua
                            (x) => x.code == id
                        ) === "undefined"
                    ) {
                        isValid = false;
                    }
                });
            }
            return isValid;
        },
        goToSetting(item) {
            this.settingScreen.id = item.code;
            this.settingScreen.title = item.name;
            this.settingScreen.data = item;
        },
    },
};
</script>
